module.exports = __webpack_public_path__ + "img/section5-item2.954a6b16.svg";